import { render } from "./UserProfile.vue?vue&type=template&id=879b8764"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=879b8764&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__